import { environment } from '../../../environments/environment';

/** Hostnames the local dev server is ever reachable on. */
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '']);

/**
 * Single definition of "run without a real Azure AD B2C login", honoured by BOTH the route guards
 * and the HTTP interceptor. It used to live only in the interceptor, which sent an unsigned dev JWT
 * while the guards still demanded an MSAL account — so the local build was configured to skip login
 * yet no guarded page could actually be opened (WI #1345).
 *
 * The bypass needs two independent conditions, because the build flag alone is not a safe gate once
 * it decides whether a user is let in at all:
 *  - `environment.skipAuth` — intent, true only in environment.ts / environment.local.ts;
 *  - the page is actually served from localhost — fact, checked at runtime.
 *
 * The second one is what makes a misconfigured deploy inert: a cloud build that somehow shipped
 * `skipAuth: true` still enforces the real login, because the browser is not on localhost. Note that
 * `environment.production` deliberately is NOT the check here — environment.dev.ts (dev-cloud) sets
 * it to false, so it would not have protected that environment.
 */
export function isAuthBypassed(hostname: string = globalThis.location?.hostname ?? ''): boolean {
  if (!environment.skipAuth) return false;
  return LOCAL_HOSTS.has(hostname);
}
